import { Grid, Icon, Typography } from "@mui/material"
import { ImportValidationError } from "../../generated/graphql"
import styles from './ShowInterventionImportErrors.module.scss'
import { Error } from "@mui/icons-material"

interface ShowInterventionImportErrorsProps {
    errors: ImportValidationError[]
}

const getErrorMessage = (error: ImportValidationError): string => {
    if (error.code === "DOCUMENT_ERROR") {
        return `Erro na linha ${error?.address} ${error?.value}.`
    }
    if (error.code === "ROW_ERROR") {
        return `Erro na linha ${error?.address} ${error?.value}.`
    }
    return `Erro na célula ${error?.address} valor ${error?.value} não é válido.`
}

export default function ShowInterventionImportErrors(props: ShowInterventionImportErrorsProps) {
    const { errors } = props

    if (!errors?.length) {
        return null
    }

    return (
        <div className={styles.Wrapper}>

            <Typography variant="h4" color="secondary">
                <Grid container alignItems="center" className={styles.Header}>
                    <Icon><Error /></Icon> <span className={styles.Title}>Erros</span>
                </Grid>
            </Typography>

            <Typography variant="body1" color="secondary">
                Não é possível prosseguir sem resolver os seguintes erros.
            </Typography>

            <div className={styles.ErrorsList}>
                {
                    errors.map(error => (
                        <Typography variant="body1" color="error">
                            {getErrorMessage(error)}
                        </Typography>
                    ))
                }
            </div>
        </div>
    )
}
